
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.975 15.683a.618.618 0 01-.442-.183l-5.058-5.058a.629.629 0 010-.884L7.533 4.5a.629.629 0 01.884 0 .629.629 0 010 .883L3.8 10l4.617 4.617a.629.629 0 010 .883.605.605 0 01-.442.183z","fill":"#112A46"}}),_c('path',{attrs:{"d":"M17.083 10.625H3.058A.63.63 0 012.433 10a.63.63 0 01.625-.625h14.025a.63.63 0 01.625.625.63.63 0 01-.625.625z","fill":"#112A46"}})])
          )
        }
      }
    